import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import InputField from "../inputComponents/InputField";
import SelectField from "../inputComponents/SelectField";
import FileUpload from "../appComponents/FileUpload";
/* For Image Crop */
import Crop from "../appComponents/Crop";
import CropRatio from "../appComponents/CropRatio";
/* End of For Image Crop */

const ModalMSlide = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const ADMINNAME = localStorage.getItem("auth_name");

  const [btnLoading, setBtnLoading] = useState("POST MANAGEMENT SLIDE");
  const [actionType, setActionType] = useState("");
  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  //Fetches all Form Data
  const [allformData, setAllFormData] = useState({
    input: {
      item03: null,
      item03b: null,
      status02: null,
      dater: getTodayDate(), // ✅ default today
    },
    select: {
      position: null,
    },
  });

  /* For Image Crop */
  const [returnRatio, setReturnRatio] = useState("");
  const [returnCrop, setReturnCrop] = useState("");
  const [cropImage, setCropImage] = useState("");
  const [closeModal, setCloseModal] = useState(false);
  /* End of For Image Crop */

  const [returnUpload, setReturnUpload] = useState("");
  const [options, setOptions] = useState({
    positionUse: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
    ],
    position: [],
  });
  // function extractColumn(arr, column) {
  //   return arr.map((x) => x[column]);
  // }
  // const [options, setOptions] = useState({
  //   name: [],
  // });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setAllFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  //replaces each first character of a word with its uppercase version
  function ucwords(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }
  useEffect(() => {
    setReturnRatio("Passport");
    setAllFormData((prev) => ({
      ...prev,
      input: {
        item03: props.editposts.item03,
        item03b: props.editposts.item03b,
        status02: props.editposts.status02,
        dater: props.editposts.dater || getTodayDate(),
        // ? new Date(props.editposts.dater * 1000)
        //     .toISOString()
        //     .split("T")[0]
        // : ""
      },

      select: {
        position: props.editposts.position,
      },
    }));

    setBtnLoading(props.modalTitle);

    (async () => await populateSelectMenu())();
  }, [props.editposts, props.modalTitle]);

  const populateSelectMenu = async () => {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}pagdata?itemName[eq]=top_manag&status02[eq]=publish`,
        ),
      ]);

      const [item02bData] = responses;

      //// eleminate all ready used positions  ////
      const usedPositions = item02bData.data.allData.map((item) =>
        item.position?.toString().trim(),
      );

      const filtered = options.positionUse.filter(
        (pos) => !usedPositions.includes(pos),
      );

      if (props.editposts.position != null && props.editposts.position !== "") {
        filtered.push(props.editposts.position);
      }

      setOptions((prev) => ({
        ...prev,
        position: filtered,
      }));
    } catch (error) {
      swal("Error", "There were no Data found!", "error");
    }
  };

  async function submitUpload(event) {
    event.preventDefault();
    setBtnLoading(<div>Processsing...</div>);

    let urlpost;

    if (props.modalTitle === "POST MANAGEMENT SLIDE") {
      urlpost = `${BASE_URL}pagdata`;
    } else {
      urlpost = `${BASE_URL}pagdata/update`;
    }

    if (!returnUpload.myFile) {
      console.log("No file Selected");
      return swal(
        "Caution",
        "Please select a file or image to upload",
        "warning",
      );
    }

  
    let fileType = 1;

    if (returnCrop) {
      
      fileType = 2;
    }

    let formData;

    formData = new FormData();
    if (actionType === "post") {
      formData.append("action", "post");
    }
    if (actionType === "copy") {
      formData.append("action", "copy");
    }
    formData.append("item01", returnCrop ? returnCrop : returnUpload.myFile[0]); //upload
    formData.append("fileType", fileType);
    formData.append("myFileUpdate", returnUpload.myFileUpdate); // We will have to delete the old image / file after uploading the new upload

    formData.append("item03", ucwords(allformData.input.item03)); // Office
    formData.append("item03b", ucwords(allformData.input.item03b)); // Persons Name
    formData.append("status02", allformData.input.status02);
    formData.append("dater", allformData.input.dater);
    formData.append("position", allformData.select.position);
    formData.append("staff", ADMINNAME);
    formData.append("itemName", "top_manag");
    formData.append("id", props.editposts.id);

    await axios.get(`sanctum/csrf-cookie`).then((response) => {
      try {
        axios.post(urlpost, formData).then((res) => {
          if (res?.data?.status === 200) {
            console.log("###222", res.data.message);
            swal("Success", res.data.message, "success");
            setBtnLoading(btnLoading);
            props.formCleanners();
            props.setCloseModal(true);
          } else {
            console.log("###333", res.data.message);
            swal("Oops!", res.data.message, "error");
          }
        });
      } catch (error) {
        console.log("###444", error.response.data);
        swal("Oops!", "Failed", "error");
        console.log(error.response.data);
      }
    });
  }

  return (
    <>
      {closeModal ? (
        <Crop
          imageCropUrl={cropImage}
          setReturnCrop={setReturnCrop}
          returnRatio={returnRatio}
          setCloseModal={setCloseModal}
        />
      ) : null}
      <form onSubmit={submitUpload} encType="multipart/form-data">
        <div className="row">
          <div className="col-md-9 mb-3">
            <div className="card">
              <div
                className={`card-header text-white bg-${props.btnColors} p-3`}
              >
                <i className="fa fa-newspaper"></i> {props.modalTitle}
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <InputField
                    label="Title"
                    name="item03"
                    size="6"
                    placeholder="Please Type in a Title"
                    required="required"
                    value={allformData.input.item03}
                    type="text"
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <InputField
                    label="Caption"
                    name="item03b"
                    size="6"
                    placeholder="Please Type in a Caption or Name"
                    required="required"
                    value={allformData.input.item03b}
                    type="text"
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <SelectField
                    label="Position"
                    name="position"
                    size="6"
                    placeholder="Select a Position"
                    required="required"
                    value={allformData.select.position}
                    options={options.position}
                    type="text"
                    switchOptions={0}
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <InputField
                    label="Start Date"
                    name="dater"
                    size="6"
                    placeholder="Please Select Start Date"
                    required="required"
                    value={allformData.input.dater}
                    type="date"
                    onChange={updateFormData}
                    icon="fa fa-calendar-check-o"
                  />

                  <div className="col-lg-6 p-4 row">
                    <InputField
                      label="Save As Draft"
                      size="8"
                      name="status02"
                      type="checkbox"
                      checked={allformData.input.status02 === "draft"}
                      value="draft"
                      onChange={updateFormData}
                    />

                    <InputField
                      label="Publish"
                      size="4"
                      name="status02"
                      type="checkbox"
                      checked={allformData.input.status02 === "publish"}
                      value="publish"
                      onChange={updateFormData}
                    />
                  </div>
                  <div className="row m-1">
                    <div className="col-lg-6 ps-4">
                      <div className="form-group mt-2">
                        <button
                          className={`btn btn-${props.btnColors} col-lg-12 mt-4`}
                          onClick={() => setActionType("post")}
                        >
                          <div className="d-flex align-items-center justify-content-center w-100">
                            <i className="fa fa-edit m-1"></i>
                            <span>{btnLoading}</span>
                          </div>
                        </button>
                      </div>
                    </div>

                    <div className="col-lg-6 ps-4">
                      <div className="form-group mt-2">
                        <button
                          className={`btn btn-secondary col-lg-12 mt-4`}
                          onClick={() => setActionType("copy")}
                        >
                          <div className="d-flex align-items-center justify-content-center w-100">
                            <i className="fa fa-clone m-1"></i>
                            <span>COPY POST</span>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3 mb-3">
            {/* {tagName} */}
            {/* send data to be displayed, collect processed result for the parent componet*/}
            <FileUpload
              editposts={props.editposts.item01}
              setReturnUpload={setReturnUpload}
              maxFiles={1} //maxFiles={5} or multiple
              titileHead={"PASSPORT UPLOAD"}
            />
            <CropRatio
              setCloseModal={setCloseModal}
              setCropImage={setCropImage}
              returnUploader={returnUpload.myFileUrl?.[0]}
              setReturnRatio={setReturnRatio}
              defaultRatio={returnRatio}
            />
          </div>
        </div>
      </form>
    </>
  );
};
export default ModalMSlide;
